import { render, staticRenderFns } from "./PackagesLicenses.vue?vue&type=template&id=4693bcc4&scoped=true"
import script from "./PackagesLicenses.vue?vue&type=script&lang=js"
export * from "./PackagesLicenses.vue?vue&type=script&lang=js"
import style0 from "./PackagesLicenses.vue?vue&type=style&index=0&id=4693bcc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4693bcc4",
  null
  
)

export default component.exports